import HtmlElement from './HtmlElement';

/**
 * MediaText
 *
 * @return Array
 */
const MediaText = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		MEDIA_TEXT: '.media-text'
	};

	/**
	 * MediaText
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class MediaText extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('intersected');
						observer.unobserve(entry.target);
					}
				});
			}, { threshold: 0.4 });

			observer.observe(this.$element.get(0));
		}
	}

	return MediaText._getElements(Selector.MEDIA_TEXT, MediaText);
})();

export default MediaText;
